import React from 'react';
import { X, User, Mail, Phone, Calendar, MessageSquare, AlertCircle, Home } from 'lucide-react';

const ViewInquiryModal = ({ isOpen, onClose, inquiry }) => {
    if (!isOpen || !inquiry) return null;

    const statusColors = {
        'New': 'bg-blue-100 text-blue-800',
        'In Progress': 'bg-yellow-100 text-yellow-800',
        'Resolved': 'bg-green-100 text-green-800',
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl w-[95%] max-w-2xl overflow-hidden animate-fade-in-up flex flex-col max-h-[90vh]">

                {/* Header */}
                <div className="flex justify-between items-center p-4 md:p-6 border-b border-gray-100 bg-gray-50 flex-shrink-0">
                    <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                        <MessageSquare className="w-5 h-5 text-blue-600" />
                        Inquiry Details
                    </h3>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-gray-200 rounded-full transition-colors text-gray-500 hover:text-gray-700"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {/* Body */}
                <div className="p-4 md:p-8 space-y-6 overflow-y-auto custom-scrollbar">
                    {/* Top Row: Basic Info */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start gap-3">
                            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
                                <User className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">Name</p>
                                <p className="text-gray-800 font-medium text-lg">{inquiry.firstName} {inquiry.lastName}</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <div className="p-2 bg-purple-50 text-purple-600 rounded-lg">
                                <Mail className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">Email</p>
                                <p className="text-gray-800 font-medium">{inquiry.email}</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <div className="p-2 bg-green-50 text-green-600 rounded-lg">
                                <Phone className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">Phone</p>
                                <p className="text-gray-800 font-medium">{inquiry.phone}</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <div className="p-2 bg-orange-50 text-orange-600 rounded-lg">
                                <Calendar className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">Date</p>
                                <p className="text-gray-800 font-medium">

                                    {new Date(inquiry.createdAt).toLocaleDateString('en-GB', {
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                    })}

                                </p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3">
                            <div className="p-2 bg-pink-50 text-pink-600 rounded-lg">
                                <Home className="w-5 h-5" />
                            </div>
                            <div>
                                <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">Interested In</p>
                                <p className="text-gray-800 font-medium">
                                    {inquiry.projectName ? inquiry.projectName : <span className="text-gray-400 italic">General Inquiry</span>}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Status Banner */}
                    <div className={`p-4 rounded-lg flex items-center gap-3 ${statusColors[inquiry.status] || 'bg-gray-100'}`}>
                        <AlertCircle className="w-5 h-5" />
                        <div>
                            <span className="font-semibold mr-2">Current Status:</span>
                            <span className="uppercase tracking-wide font-bold">{inquiry.status}</span>
                        </div>
                    </div>

                    {/* Message */}
                    <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                        <div className="flex items-center gap-2 mb-3 text-gray-500">
                            <MessageSquare className="w-4 h-4" />
                            <h4 className="text-sm font-semibold uppercase tracking-wider">Message</h4>
                        </div>
                        <p className="text-gray-700 leading-relaxed whitespace-pre-wrap text-base">
                            {inquiry.message}
                        </p>
                    </div>
                </div>

                {/* Footer
                <div className="p-6 bg-gray-50 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 bg-gray-800 text-white font-medium rounded-lg hover:bg-gray-900 transition-colors shadow-lg shadow-gray-200"
                    >
                        Close
                    </button>
                </div> */}
            </div >
        </div >
    );
};

export default ViewInquiryModal;
